import { SubscriberCommunicationPreferencesDto } from 'enrollment/queries';

export const getInitialValues = () => {
  return {
    email: '',
    phone: '',
    phoneType: '',
    text: false,
    emailConsent: false,
    phoneConsent: false,
  };
};

export const getFormValues = () => {
  const form = document.getElementById(
    'communication-preferences-form'
  ) as HTMLFormElement;

  const inputElems = form.querySelectorAll('input');
  const response = {};

  inputElems.forEach((input) => {
    if (input.type === 'checkbox') {
      Object.assign(response, {
        [input.id]: input.checked,
      });
    } else {
      if (input.id === 'phone_number') {
        Object.assign(response, {
          [input.id]: formatPhoneNumber(input.value),
        });
      } else {
        Object.assign(response, {
          [input.id]: input.value,
        });
      }
    }
  });

  return response as SubscriberCommunicationPreferencesDto;
};

const formatPhoneNumber = (num: string) => {
  return num.replaceAll(/\D/g, '');
};
